module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Regular.97aa35ad8b5c6f4470fe54d66546f1c7.ttf";